import { Component, OnInit } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { ShowHideLoaderService } from './Shared/show-hide-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'APMUI';
  constructor (private router: Router,private showloader:ShowHideLoaderService) {}

  ngOnInit () {
    this.router.events.subscribe(event => {
        if (event instanceof RouteConfigLoadStart) {
          this.showloader.ShowHide(true);
        } else if (event instanceof RouteConfigLoadEnd) {
          this.showloader.ShowHide(false);
        }
    });
  }
}
